import { createRouter } from '@tanstack/react-router';

import { ErrorFallback } from '@/components/error';
import { Loading } from '@/components/loading';
import { queryClient } from '@/lib/query-client';
import { routeTree } from '@/routeTree.gen';

export const router = createRouter({
    routeTree,
    defaultPendingComponent: Loading,
    defaultErrorComponent: ErrorFallback,
    context: {
        queryClient,
        isAuthenticated: null!,
        currentUser: null!,
    },
    scrollRestoration: true,
    scrollToTopSelectors: ['[data-slot="sidebar-inset"]'],
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 1000 * 60 * 60, // 1 hour
});

declare module '@tanstack/react-router' {
    // eslint-disable-next-line ts/consistent-type-definitions
    interface Register {
        router: typeof router;
    }
}
